<div class="date-stamp">
  <div class="date-stamp__week-day" >{{  weekDay }}</div>
  <div class="date-stamp__month" >{{ month }}</div>
  <div class="date-stamp__month-day">{{ monthDay }}</div>
</div>
